import { createSlice, PayloadAction } from '@reduxjs/toolkit';

/**
 * The Angular `CounsellingService` doubled as a hand-off channel between
 * components through two fields:
 *
 *   rowDataVal(row) / getRowDataVal()          -> rowData
 *   counsellingData(val) / getCounsellingData() -> SelectedCounselling
 *
 * A module-level variable would not re-render React, so that state lives here.
 */

/* eslint-disable @typescript-eslint/no-explicit-any */
/** Both values were untyped in Angular - grid rows and counselling records. */
type Handoff = any;
/* eslint-enable @typescript-eslint/no-explicit-any */

/**
 * The values DEE.clickStart used to write to localStorage as a hand-off to the
 * order-copy / vacancy pages. Kept in Redux instead so they re-render and clear
 * with the rest of the counselling hand-off state.
 */

export interface CounsellingState {
  /** Angular: CounsellingService.rowData */
  rowData: Handoff;
  /** Angular: CounsellingService.SelectedCounselling */
  selectedCounselling: Handoff;
}

const initialState: CounsellingState = {
  rowData: null,
  selectedCounselling: null,
};

const counsellingSlice = createSlice({
  name: 'counselling',
  initialState,
  reducers: {
    /** Angular: rowDataVal(rowdata) */
    setRowData(state, action: PayloadAction<Handoff>) {
      state.rowData = action.payload;
    },
    /** Angular: counsellingData(val) */
    setSelectedCounselling(state, action: PayloadAction<Handoff>) {
      state.selectedCounselling = action.payload;
    },
    clearCounsellingHandoff() {
      return initialState;
    },
  },
});

export const { setRowData, setSelectedCounselling, clearCounsellingHandoff } =
  counsellingSlice.actions;
export default counsellingSlice.reducer;
